'use client'
import {
  switchSizeClasses,
  thumbSizeClasses
} from "./chunk-ARB5QNBR.mjs";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/Switch/Switch.tsx
import { useId } from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { twMerge } from "tailwind-merge";
import { jsx, jsxs } from "react/jsx-runtime";
var Switch = (_a) => {
  var _b = _a, {
    label,
    error,
    hideErrorSpace = false,
    className,
    disabled,
    groupClassName,
    id: _id,
    onChange,
    size = "S"
  } = _b, props = __objRest(_b, [
    "label",
    "error",
    "hideErrorSpace",
    "className",
    "disabled",
    "groupClassName",
    "id",
    "onChange",
    "size"
  ]);
  const id = useId();
  return /* @__PURE__ */ jsxs("div", { className: groupClassName, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ jsx(
        SwitchPrimitive.Root,
        __spreadProps(__spreadValues({
          className: twMerge(
            "data-[state=checked]:bg-primary bg-body-level-2 group relative inline-flex shrink-0 items-center rounded-full disabled:cursor-not-allowed disabled:opacity-50",
            switchSizeClasses[size],
            className
          ),
          id: _id || id,
          disabled,
          onCheckedChange: onChange
        }, props), {
          children: /* @__PURE__ */ jsx(
            SwitchPrimitive.Thumb,
            {
              className: twMerge(
                "inline-block transform rounded-full bg-white transition ltr:translate-x-px rtl:-translate-x-px",
                thumbSizeClasses[size]
              )
            }
          )
        })
      ),
      label && /* @__PURE__ */ jsx(
        "label",
        {
          htmlFor: _id || id,
          "aria-disabled": disabled,
          className: "cursor-pointer aria-disabled:cursor-not-allowed",
          children: label
        }
      )
    ] }),
    typeof error === "string" && !!error || !hideErrorSpace ? /* @__PURE__ */ jsx("p", { className: "text-error my-1 min-h-[16px] text-xs", children: error }) : null
  ] });
};
var Switch_default = Switch;

export {
  Switch_default
};
//# sourceMappingURL=chunk-HYF7U3D2.mjs.map